module.exports = "mat-card {\n  padding: 0; }\n  mat-card mat-toolbar .fill-remaining {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto; }\n  mat-card mat-toolbar .loading-msg {\n    font-size: 0.9rem; }\n  mat-card mat-card-content {\n    padding: 16px; }\n  mat-card mat-card-content form {\n      width: 500px; }\n  mat-card mat-card-content form mat-input-container {\n        display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/login/change-password/change-password.component.scss
// module id = ./libs/atenea-cms/src/login/change-password/change-password.component.scss
// module chunks = main